import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-success-upload-file',
  templateUrl: './dialog-success-upload-file.component.html',
  styleUrls: ['./dialog-success-upload-file.component.css']
})
export class DialogSuccessUploadFileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
